import { axios } from '@/lib/axios'
import { useNotificationStore } from '@/store/notification'
import { useMutation } from '@tanstack/react-query'
import { ContactFormValues } from '../components/ContactForm'

const sendMessage = (data: ContactFormValues) => {
  return axios.post('/contact', data)
}

export const useSendMessage = () => {
  const { addNotifcation } = useNotificationStore()
  return useMutation({
    onSuccess: () => {
      addNotifcation({
        title: 'Success',
        message: 'We have received your message! We will get back to you soon',
        type: 'success',
      })
    },
    mutationFn: sendMessage,
  })
}
